import React, { memo, useCallback, useState, useEffect } from 'react';
import Select, { SingleValue } from 'react-select';
import { Config } from '../../helpers/config';

export type HourOption = {
  value: string;
  label: string;
};

type HourSelectorProps = {
  onChange: (option: string | undefined) => void;
  value: string;
  options: HourOption[];
};

export const HourSelector: React.FC<HourSelectorProps> = memo(
  ({ options, onChange, value }) => {
    const [selectedValue, setSelectedValue] = useState<HourOption>();

    useEffect(() => {
      const elem = options.find((o) => o.value === value);
      setSelectedValue(elem);
    }, [value, options]);

    const onValueChange = useCallback(
      (newValue: SingleValue<HourOption>) => {
        onChange(newValue?.value);
      },
      [onChange]
    );

    return (
      <Select
        onChange={onValueChange}
        value={selectedValue}
        placeholder=""
        styles={{
          indicatorSeparator: (provided) => ({
            ...provided,
            display: 'none',
          }),
          control: (provided, state) => ({
            ...provided,
            borderRadius: '10px',
            boxShadow: state.isFocused
              ? '0 0 0 1px ' + Config.primaryBlue
              : undefined,
          }),
          option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
              ? Config.primaryBlue
              : provided.backgroundColor,
          }),
          container: (provided) => ({
            ...provided,
            width: '70px',
          }),
          dropdownIndicator: (provided) => ({
            ...provided,
            paddingLeft: '0px',
          }),
        }}
        isSearchable={false}
        options={options}
      />
    );
  }
);
